export enum DecisionRequirement
{
  None,
  OptionalYesNo,
  MandatoryYes,
  MandatoryNo
}
export enum DecisionRequirementString
{
  'None',
  'Optional Yes & No',
  'Mandatory Yes',
  'Mandatory No'
}
